<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="6" style="width: 80%;background-size: cover; margin: auto;">
            <div>
                <br /> <br /> <br /> <br />
                <CCard>
                    <div class="text-center" style="margin:10%">
                        <img :src="qrCodeUrl" alt="QR Code" style="max-width:100%">
                        <h1 class="font-general-sans text-center custom-18px-600">
                                Scan QR Code
                            </h1>
                        <h4 class="custom-14px-400">To begin your interview, please scan the QR code <br /> below with your mobile device. It will open a link where you can join the interview.</h4>
                    </div>
    
                </CCard>
            </div>
    
        </CCol>
    </div>
</template>
  
<script>
import QRCode from 'qrcode-generator';
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


export default {
    components: {
        Mainlayout,
    },
    data() {
        return {
            qrValue: 'https://surpriz.ing/directinterview?code=' + this.$route.query.code,
            qrCodeUrl: ''
        };
    },
    created() {
        this.generateQRCode();
    },
    methods: {
        generateQRCode() {
            const qr = QRCode(0, 'L');
            qr.addData(this.qrValue);
            qr.make();
            this.qrCodeUrl = qr.createDataURL(6); // 6 is the scale factor, you can adjust as needed
        }
    }
};
</script>
  
<style>
/* Add any styles you want here */
</style>
  